import React from 'react'
import { Card, Image, Label, Icon} from 'semantic-ui-react';
import styled from 'styled-components';
import { theme } from '../../style/theme';

const { colors, fonts, fontSizes } = theme;

const StyledContainer = styled.div`
    margin-right:20px !important;
    margin-left: 20px !important;
    margin-bottom: 30px !important;
    display: flex;
`;

const StyledCard = styled(Card)`
    background: ${colors.bg} !important;
    box-shadow: none !important;
    box-shadow: 0 10px 30px -15px ${colors.secondary} !important;
    position: relative !important;
`;

const StyledImage = styled(Image)`
    height:200px !important;
`;

const StyledCardBody = styled(Card.Content)`
    display: block !important;
    justify-content: center;
    align-items: center;
    text-align: center !important;
    margin-top:10px !important;
`;

const StyledProjectName = styled.h1`
    font-family: ${ fonts.SFMono};
    font-size: 15px;
    color: ${ colors.secondary};
    margin: auto !important;
    margin-bottom:10px !important;
    margin-top:50px;
`;

const StyledProjectFooter = styled(Card.Content)`
    background: ${colors.secondary} !important;
    display: flex !important;
    justify-content: flex-start !important;;
    align-items: flex-start !important;
    padding:10px !important;
`;

const StyledWebsiteLink = styled.a`
    position: absolute !important;
    left:110px !important;
    top: 165px !important;
    background: ${colors.bg} !important;
    width: 70px;
    height: 70px;
    border-radius: 100%;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: auto;
    &:hover {
        transform: scale(1.2) 
    }

`;
const StyledIcon = styled(Icon)`
    color: white !important;
    background: ${colors.secondary} !important;
    border: none !important;
    border-color: white !important;
    box-shadow: none !important;
    margin: auto !important;
`;


const StyledLabelGroup = styled.div`
    display: block;
    flex-flow: row wrap;
    justify-content: space-between;
`;

const StyledLabel = styled(Label)`
    margin-bottom:10px !important;
`;

const StyledDescripiton = styled.div`
    font-size: ${fontSizes.sm};
`;



const CardUI = (props) => {

    let technoUse =  props.technos
                                .map((techno,index)=>(<StyledLabel key={index}> {techno} </StyledLabel>));

    return (
        <>
        <StyledContainer>

        
            <StyledCard>
                    <StyledImage src={props.image} />
                    {props.external !== "" &&
                        <StyledWebsiteLink href={props.external} target="_blank">
                            <StyledIcon name="play"  circular />
                        </StyledWebsiteLink>
                    }
                <StyledCardBody>
                    <StyledProjectName> {props.name} </StyledProjectName>
                <StyledDescripiton> { props.description } </StyledDescripiton>
                </StyledCardBody>

                <StyledProjectFooter>
                        <StyledLabelGroup>
                            {technoUse}
                        </StyledLabelGroup>
                </StyledProjectFooter>
            </StyledCard>
            
        </StyledContainer>
        </>
        
    )
};

export default CardUI;


